import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { DialogOverlay as DialogOverlay$1 } from '@reach/dialog';
import { useTheme } from '../hooks/useTheme.js';

var DialogOverlay = forwardRef(function DialogOverlay(_a, ref) {
    var children = _a.children, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.allowPinchZoom, allowPinchZoom = _c === void 0 ? false : _c, _d = _a.onDismiss, onDismiss = _d === void 0 ? function () {
        return;
    } : _d, sx = _a.sx, _e = _a.themeKey, themeKey = _e === void 0 ? "dialogOverlay" : _e, props = __rest(_a, ["children", "isOpen", "allowPinchZoom", "onDismiss", "sx", "themeKey"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ sx: sx, tone: "black" }, {
        themeKey: themeKey,
    });
    return (jsx(DialogOverlay$1, __assign({ ref: ref, isOpen: isOpen, allowPinchZoom: allowPinchZoom, onDismiss: onDismiss }, forwardProps, props, { children: children })));
});

export { DialogOverlay };
//# sourceMappingURL=DialogOverlay.js.map
